// export default {
//   ...(process.env.NODE_ENV === 'development' && 0 ? require('./dev') : require('./prod'))
// }
const dev = require('./dev');
const prod = require('./prod');
const config = process.env.NODE_ENV === 'development' ? dev: prod;
module.exports = config;


// WEBPACK FOOTER //
// ./src/config/index.js